import React from "react";
import { Results as ReactifyResult, useSearch } from "@usereactify/search";

import { ProductCard } from "../components/Cards/cards";
import { ResultPaginationNumbered } from "../components/Paginations/paginations";
import { SkeletonCards } from "../components/Cards/skeletonCards";
import useMedia from "../../hooks/useMedia";

export const Results: React.FC = () => {
  const { isSmall } = useMedia();

  return (
    <ReactifyResult
      listStyle={{
        display: "grid",
        gap: "4px",
        gridTemplateColumns: isSmall ? "repeat(2, minmax(0, 1fr))" : "repeat(4, minmax(0, 1fr))",
      }}
      renderLoading={() => <SkeletonCards />}
      renderResultCardProduct={(props) => <ProductCard {...props} />}
      renderPaginationNumbered={(props) => <ResultPaginationNumbered {...props} />}
      renderNoResults={() => <div></div>}
    />
  );
};

export const InstantSearchResults: React.FC = () => {
  const { searchTerm } = useSearch();

  return searchTerm ? (
    <div>
      <ReactifyResult
        pageSize={6}
        listStyle={{
          display: "grid",
          gap: "4px",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          paddingTop: "24px",
        }}
        renderResultCardProduct={(props) => <ProductCard {...props} isSlider={false} />}
        renderPaginationNumbered={(props) => <ResultPaginationNumbered {...props} />}
      />
    </div>
  ) : (
    <></>
  );
};